import { render, staticRenderFns } from "./SalePayment.vue?vue&type=template&id=64acdd82&scoped=true&"
import script from "./SalePayment.vue?vue&type=script&lang=js&"
export * from "./SalePayment.vue?vue&type=script&lang=js&"
import style0 from "./SalePayment.vue?vue&type=style&index=0&id=64acdd82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.12_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64acdd82",
  null
  
)

export default component.exports